// Lexical's markdown import counts one list level per 4 spaces, but models
// (and CommonMark) nest list items with 2 or 3. Re-indent each nested list
// item to 4 spaces per level, working out its depth from the indents of the
// list items above it, so 2-, 3- and 4-space nesting all import the same way.

const LIST_ITEM = /^( *)([-*+]|\d{1,9}[.)])(?=\s)/;
const FENCE = /^\s*(```|~~~)/;
const LIST_INDENT_SIZE = 4;

export function normalizeListIndent(markdown: string): string {
  // Indents (as written) of the list items enclosing the current line, outermost first.
  let parents: number[] = [];
  let inFence = false;

  return markdown
    .split('\n')
    .map((line) => {
      if (inFence) {
        inFence = !FENCE.test(line);
        return line;
      }
      if (line.trim() === '') {
        return line;
      }
      const match = LIST_ITEM.exec(line);
      if (!match) {
        // Unindented text ends the list; indented text continues the item above.
        if (!/^\s/.test(line)) {
          parents = [];
        }
        inFence = FENCE.test(line);
        return line;
      }
      const indent = match[1].length;
      // An item nests under one indented at least 2 spaces less; within 1 space it's a sibling.
      while (parents.length && indent <= parents[parents.length - 1] + 1) {
        parents.pop();
      }
      const depth = parents.length;
      parents.push(indent);
      return ' '.repeat(depth * LIST_INDENT_SIZE) + line.slice(indent);
    })
    .join('\n');
}
